<template>
  <v-card>
    <v-system-bar window :color="color">
      {{ title }}
    </v-system-bar>

    <v-list>
      <v-list-item v-if="isNew">
        <CoursePartInput
          v-model="course"
          :schoolClass="schoolClass ? schoolClass.id : null"
          :person="teacher ? teacher.id : null"
          :startDate="date"
          :endDate="date"
          label="Kurs"
        ></CoursePartInput>
      </v-list-item>
      <Course v-else :value="lesson.course"></Course>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <DateValue :value="date" full></DateValue>
          </v-list-item-title>

          <v-list-item-subtitle v-if="!isNew">
            {{ lesson.startTime }} – {{ lesson.endTime }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isNew">
        <LookupValueInput
          v-model="site"
          label="Standort"
          resource="common/site"
        ></LookupValueInput>
      </v-list-item>
      <v-list-item v-if="isNew">
        <PeriodInput
          :disabled="!site"
          v-model="period"
          :site="site"
          label="Lektion"
        ></PeriodInput>
      </v-list-item>

      <LookupValueBtnToggle
        v-if="!isNew && status.code != 'inserted'"
        v-model="status"
        resource="register/lessonstatus"
        :color="color"
        :disabled="lesson.status.code != 'asPlanned'"
        mandatory
      ></LookupValueBtnToggle>
      <v-list-item>
        <RoomInputMulti
          :site="site"
          v-model="rooms"
          :disabled="
            !isNew &&
            (!status || status.code != 'roomChange') &&
            (!status || status.code != 'inserted')
          "
        ></RoomInputMulti>
      </v-list-item>

      <v-list-item>
        <v-text-field
          label="Kommentar (optional)"
          v-model="comments"
        ></v-text-field>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        color="danger"
        text
        @click="undoLessonChange()"
        :loading="undoing"
        v-if="
          !isNew && lesson && lesson.status && lesson.status.code != 'asPlanned'
        "
      >
        rückgängig
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')"> abbrechen </v-btn>

      <v-btn
        :color="isNew ? 'success' : 'primary'"
        text
        @click="save()"
        :loading="saving"
        :disabled="!status || status.code == 'asPlanned'"
      >
        Speichern
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { defineComponent } from "vue";
import Course from "@/components/Course.vue";
import CoursePartInput from "common/components/CoursePartInput.vue";
import DateValue from "common/components/DateValue.vue";
import LookupValueBtnToggle from "common/components/LookupValueBtnToggle.vue";
import LookupValueInput from "common/components/LookupValueInput.vue";
import PeriodInput from "common/components/PeriodInput.vue";
import RoomInputMulti from "@/components/RoomInputMulti.vue";

import { lessonStatusColor } from "common/utils/icons.js";

export default defineComponent({
  name: "LessonChangesForm",
  components: {
    Course,
    CoursePartInput,
    DateValue,
    LookupValueBtnToggle,
    LookupValueInput,
    PeriodInput,
    RoomInputMulti,
  },
  props: ["date", "lesson", "schoolClass", "teacher"],
  data: () => ({
    comments: "",
    course: null,
    period: null,
    rooms: [],
    saving: false,
    site: null,
    status: null,
    undoing: false,
  }),
  computed: {
    color() {
      return this.isNew || this.status.code == "asPlanned"
        ? ""
        : lessonStatusColor(this.status);
    },
    isNew() {
      return this.lesson && this.lesson.id == 0;
    },
    item() {
      if (this.isNew) {
        return {
          date: this.date,
          period: { id: this.period ? this.period.id : 0 },
          course: { id: this.course ? this.course.id : 0 },
          rooms: this.rooms
            .filter((el) => el != undefined)
            .map((el) => {
              return { id: el.id };
            }),
          comments: this.comments,
        };
      }

      return {
        id: this.lesson.lessonId,
        status: { id: this.status ? this.status.id : 0 },
        rooms: this.rooms
          .filter((el) => el != undefined)
          .map((el) => {
            return { id: el.id };
          }),
        comments: this.comments,
      };
    },
    title() {
      let result =
        this.isNew || this.status.code == "asPlanned"
          ? "Lektion"
          : this.status.description;
      result += this.isNew ? " hinzüfugen " : " ändern ";

      if (this.schoolClass) {
        result += this.schoolClass.code;
      }
      if (this.teacher) {
        result += this.teacher.code;
      }
      return result;
    },
  },
  watch: {
    lesson() {
      this.prepare();
    },
  },
  methods: {
    async undoLessonChange() {
      this.undoing = true;
      await this.apiDelete({
        resource: "register/lesson",
        id: this.lesson.lessonId,
      });
      this.$emit("update");
      this.$emit("close");
      this.undoing = false;
    },
    async save() {
      this.saving = true;
      console.log("item");
      console.log("item", this.item);
      await this.apiSave({
        resource: "register/lesson",
        add: this.isNew,
        data: this.item,
      });
      this.$emit("update");
      this.$emit("close");
      this.saving = false;
    },
    prepare() {
      this.comments = this.lesson.comments;
      this.rooms = this.lesson.rooms;
      this.status = this.lesson.status;
    },
  },
  created() {
    this.prepare();
  },
});
</script>
